
import { useState,useEffect } from "react";
import viewmyresultapi from '../api/viewmyresultapi';
import loginapi from '../api/login';
import { useNavigate } from "react-router-dom";
import { APISERVERURL } from '../APIServerURL';
import OfferedCoursesS from '../studentcomponents/OfferedCoursesS';
import SelectedImages from '../studentcomponents/SelectedImages'
import DeleteConfirmation from '../studentcomponents/ConfirmDelete';

import { FaSave } from "react-icons/fa";
import { AiOutlineDownload } from "react-icons/ai";

const ApplicationForm = ({ data, onSave, pdata, ponSave }) => {
  const [localData, setLocalData] = useState({ ...data });
  const [plocalData, setpLocalData] = useState({ ...pdata });

  const isLocked = data?.applied_status === "yes";

  const handleChange = (e) => {
    if (isLocked) return; // prevent editing
    const { name, value } = e.target;
    setLocalData((prev) => ({ ...prev, [name]: value }));
  };

  const handlepChange = (e) => {
    if (isLocked) return; // prevent editing
    const { name, value } = e.target;
    setpLocalData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = () => {
    if (!isLocked) onSave(localData);
  };

  const handlepSubmit = () => {
    if (!isLocked) ponSave(plocalData);
  };

  return (
    <div className="p-4 border rounded  w-full max-w-[600px]">
      <h2 className="text-xl font-bold mb-4 text-center">
        Application for {localData.type} certificate
      </h2>

      {/* Applied Name */}
      <div className="mb-2">
        <label className="block text-sm font-medium">Applied Name</label>
        {isLocked ? (
          <p className="p-2 ">{localData.applied_name}</p>
        ) : (
          <input
            type="text"
            name="applied_name"
            value={localData.applied_name || ""}
            onChange={handleChange}
            onBlur={handleSubmit}
            className="border p-2 w-full rounded"
          />
        )}
      </div>

      {/* Assamese Name */}
      <div className="mb-2">
        <label className="block text-sm font-medium">Applied Assamese Name</label>
        {isLocked ? (
          <p className="p-2 ">{localData.applied_assamiese_name}</p>
        ) : (
          <input
            type="text"
            name="applied_assamiese_name"
            value={localData.applied_assamiese_name || ""}
            onChange={handleChange}
            onBlur={handleSubmit}
            className="border p-2 w-full rounded"
          />
        )}
      </div>

      {/* Year of Passing */}
      <div className="mb-2">
        <label className="block text-sm font-medium">Year of Passing</label>
        {isLocked ? (
          <p className="p-2 ">{localData.applied_yop}</p>
        ) : (
          <input
            type="number"
            name="applied_yop"
            value={localData.applied_yop || ""}
            onChange={handleChange}
            onWheel={(e) => e.target.blur()}
            onBlur={handleSubmit}
            className="border p-2 w-full rounded"
          />
        )}
      </div>

      {/* Transaction No */}
      <div className="mb-2">
        <label className="block text-sm font-medium">Payment Transaction Number</label>
        {isLocked ? (
          <p className="p-2 ">{plocalData.transaction_no}</p>
        ) : (
          <input
            type="text"
            name="transaction_no"
            value={plocalData.transaction_no || ""}
            onChange={handlepChange}
            onBlur={handlepSubmit}
            className="border p-2 w-full rounded"
          />
        )}
      </div>

      {/* Amount */}
      <div className="mb-2">
        <label className="block text-sm font-medium">Paid Amount</label>
        {isLocked ? (
          <p className="p-2 ">{plocalData.amount}</p>
        ) : (
          <input
            type="number"
            name="amount"
            value={plocalData.amount || ""}
            onChange={handlepChange}
            onWheel={(e) => e.target.blur()}
            onBlur={handlepSubmit}
            className="border p-2 w-full rounded"
          />
        )}
      </div>
    </div>
  );
};

  const MarksheetForm = ({ data, onImageUpload ,submissionStatus="no"}) => {
    const [images,setImages]=useState([]);
      const [imgName,setImgName]=useState(data.images && data.images.length > 0 ? data.images[0] : '');

   useEffect(() => {
  setImgName(data.images && data.images.length > 0 ? data.images[0] : '');
}, [data]);

    const handleSubmit = (e) => {
      let formData = new FormData();    //formdata object
         
          formData.append("transaction_id", data._id);
          Object.values(images).forEach(file=>{
            formData.append("images", file);
          });
          const config = {     
              headers: { 'content-type': 'multipart/form-data' }
          }
    
      onImageUpload(e,formData);
      setImages([]);
    };

 function addToImageList(selectedFiles)
  {
      const newImages=[...images,...selectedFiles];
      setImages(newImages);
      console.log(newImages.length);
  }

    return (
      <div className="p-4 border rounded  w-full max-w-[600px] ">
        <h2 className="text-xl text-gray-400 mb-4 text-center">Final Grade Card (Consolidated)</h2>

       
<div className='w-full mt-6 mb-2 p-1'>
  <p>Uploaded Image:</p>
 {imgName && imgName!='' &&(<div className="block w-full h-[300px] overflow-hidden mt-1">
    <img
      src={`${APISERVERURL}/img/${imgName}`}
      alt="placeholder"
      className="w-65 h-full object-contain transform hover:scale-110 transition-transform duration-500"
    />
  </div>)}

  {!imgName  &&(<div className="block w-full h-[300px] overflow-hidden mt-1">
    <img
      src={`${APISERVERURL}/img/default.png`}
      alt="placeholder"
      className="w-65 h-full object-contain transform hover:scale-110 transition-transform duration-500"
    />
  </div>)}

</div>
<div>
   {submissionStatus!=='yes' && <input className="marginTop" type='file' id="fuPhotos" name="uploadedPhotos" multiple
            accept="image/png, image/jpg, image/jpeg"
            onChange={(e)=>{addToImageList(e.target.files)}}
            ></input>}

            <SelectedImages
            images={images}
            setImages={setImages}
            >
            </SelectedImages>
</div>
        
<div className="w-full flex justify-end p-2 mt-1">
{images.length>0 && (<button
          onClick={handleSubmit}
          className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600"
        >
          UPLOAD PHOTO
        </button>)}
</div>
        
      </div>
    );
  };
  const PaymentDetailsForm = ({ data, onImageUpload ,submissionStatus="no"}) => {
    const [images,setImages]=useState([]);
      const [imgName,setImgName]=useState(data.images && data.images.length > 0 ? data.images[0] : '');

   useEffect(() => {
  setImgName(data.images && data.images.length > 0 ? data.images[0] : '');
}, [data]);

    const handleSubmit = (e) => {
      let formData = new FormData();    //formdata object
         
          formData.append("transaction_id", data._id);
          Object.values(images).forEach(file=>{
            formData.append("images", file);
          });
          const config = {     
              headers: { 'content-type': 'multipart/form-data' }
          }
    
      onImageUpload(e,formData);
      setImages([]);
    };

 function addToImageList(selectedFiles)
  {
      const newImages=[...images,...selectedFiles];
      setImages(newImages);
      console.log(newImages.length);
  }

    return (
      <div className="p-4 border rounded  w-full max-w-[600px] ">
        <h2 className="text-xl text-gray-400 mb-4 text-center">Payment Receipt</h2>

       
<div className='w-full mt-6 mb-2 p-1'>
  <p>Uploaded Image:</p>
 {imgName && imgName!='' &&(<div className="block w-full h-[300px] overflow-hidden mt-1">
    <img
      src={`${APISERVERURL}/img/${imgName}`}
      alt="placeholder"
      className="w-65 h-full object-contain transform hover:scale-110 transition-transform duration-500"
    />
  </div>)}

  {!imgName  &&(<div className="block w-full h-[300px] overflow-hidden mt-1">
    <img
      src={`${APISERVERURL}/img/default.png`}
      alt="placeholder"
      className="w-65 h-full object-contain transform hover:scale-110 transition-transform duration-500"
    />
  </div>)}

</div>
<div>
   {submissionStatus!=='yes' && <input className="marginTop" type='file' id="fuPhotos" name="uploadedPhotos" multiple
            accept="image/png, image/jpg, image/jpeg"
            onChange={(e)=>{addToImageList(e.target.files)}}
            ></input>}

            <SelectedImages
            images={images}
            setImages={setImages}
            >
            </SelectedImages>
</div>
        
<div className="w-full flex justify-end p-2 mt-1">
{images.length>0 && (<button
          onClick={handleSubmit}
          className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600"
        >
          UPLOAD PHOTO
        </button>)}
</div>
        
      </div>
    );
  };


function ApplyConvocaation({accessToken,setAccessToken,setRefreshFailed}) {
  const navigate = useNavigate();   
  const [selectedSemester,setSelectedSemester]=useState(-1);
  const [isAppLoaded,setIsAppLoaded]=useState(true);
  const [semOfferedCourses,setSemOfferedCourses]=useState(null);  
  const [selectedCourses,setSelectedCourses]=useState(null);
    const [selectedType,setSelectedType]=useState('');
  const [applicationTypes,setApplicationTypes]=useState([]);

  const [showModal, setShowModal] = useState(false);

  const [loggedInStudent,setLoggedInStudent]=useState(null);
  const [convoPaymentDetails,setConvoPaymentDetails]=useState(null);
    const [convoApplicationDetails,setConvoApplicationDetails]=useState(null);
  const session='2025-MAY';

  const [isCourseSelectionOk,setIsCourseSelectionOk]=useState(false);
  const [isPaymentOk,setIsPaymentOk]=useState(false);
  const [paymentError,setPaymentError]=useState([]);
  const [courseError,setCourseError]=useState([]);

  const [submissionStatus,setSubmissionStatus]=useState('submitted');
   const [isOpen,setIsOpen]=useState('NO');
  


   ////////
  
 const handleSave =async (formData)=>{
   // console.log("Updated Data:", updatedData);
    //setFormData(updatedData);
    //alert("l");
    try{
          const response= await viewmyresultapi.post('/updateConvocationApplication',formData,{headers:{'Authorization':`Bearer ${accessToken}`}});      
         setConvoApplicationDetails(response.data.pd);
          }
          catch(err)
          {
              try{
              const config = { withCredentials: true };
              const x=await loginapi.get('/getAccessToken',config);
              //alert(JSON.stringify(x['data']['accessToken']));
              
              const nat=x['data']['accessToken'];
              setAccessToken(nat);
              //console.log(`ne at ${nat}`);
              //console.log(`Second at:${accessToken}`);
              try{       
                  const response= await viewmyresultapi.post('/updateConvocationApplication',formData,{headers:{'Authorization':`Bearer ${nat}`}});      
                 setConvoApplicationDetails(response.data.pd);
              }
              catch(err)
              {
                  alert('unusual error newposts.js');
                 
                  //navigate('/');
              }
              }
              catch(err)
              {
              alert('failed');
             
              //setError(JSON.stringify(err));
              //navigate('/');
              }

          }
  };
  const handlepSave =async (formData)=>{
   // console.log("Updated Data:", updatedData);
    //setFormData(updatedData);
    //alert("l");
    try{
          const response= await viewmyresultapi.post('/updateConvocationPayment',formData,{headers:{'Authorization':`Bearer ${accessToken}`}});      
         setConvoPaymentDetails(response.data.pd);
          }
          catch(err)
          {
              try{
              const config = { withCredentials: true };
              const x=await loginapi.get('/getAccessToken',config);
              //alert(JSON.stringify(x['data']['accessToken']));
              
              const nat=x['data']['accessToken'];
              setAccessToken(nat);
              //console.log(`ne at ${nat}`);
              //console.log(`Second at:${accessToken}`);
              try{       
                  const response= await viewmyresultapi.post('/updateConvocationPayment',formData,{headers:{'Authorization':`Bearer ${nat}`}});      
                 setConvoPaymentDetails(response.data.pd);
              }
              catch(err)
              {
                  alert('unusual error newposts.js');
                 
                  //navigate('/');
              }
              }
              catch(err)
              {
              alert('failed');
             
              //setError(JSON.stringify(err));
              //navigate('/');
              }

          }
  };
  
 
   const fetchAT=async ()=>{
          setIsAppLoaded(false);
      try{       
        //const response=await api.get('/stats',{headers:{'Authorization':`Bearer ${accessToken}`}});
        const response=await viewmyresultapi.post('/getConvocationDetailsOfTheStudent',{id:1},{headers:{'Authorization':`Bearer ${accessToken}`}});                            
        //alert(JSON.stringify(response.data.student));
        setLoggedInStudent(response.data.student);
        //alert(JSON.stringify(response.data.student.types[0]));
        setApplicationTypes(response.data.student.types);
       // setSelectedType(response.data.student.types[0]);
        }
        catch(err)
        {
          if( err.response.status===403)
            {
              navigate(`/accessdenied`); 
            }
          try{
            const config = { withCredentials: true };
            const x=await loginapi.get('/getAccessToken',config);            
            const nat=x['data']['accessToken'];
            const lt=x['data']['loginType'];
            //alert(nat);
            setAccessToken(nat);
            setRefreshFailed(false);  
                    
           
              if(lt.toLowerCase()==="student")
                {
                      try{       
                        const response=await viewmyresultapi.post('/getConvocationDetailsOfTheStudent',{id:1},{headers:{'Authorization':`Bearer ${nat}`}});                            
                        //alert(JSON.stringify(response.data.student));
                        setLoggedInStudent(response.data.student);
                        // alert(JSON.stringify(response.data.student.types[0]));
                         setApplicationTypes(response.data.student.types);
                        //setSelectedType(response.data.student.types[0]);
                    }
                    catch(err)
                    {
                      if( err.response.status===403)
                        {
                          navigate(`/accessdenied`); 
                        }
                      //alert('refresh failed unusual'+JSON.stringify(err));
                      setAccessToken('');
                      setRefreshFailed(true);  
                    }
                  }
            }
            catch(err)
            {
              //alert('dd');
              setAccessToken(''); 
              setRefreshFailed(true);              
            }
        }         
         finally
            {
              setIsAppLoaded(true);
              //alert('app loaded'+accessToken);
            }
    }
  useEffect(()=>{   
    fetchAT();
  },[]);


  const getSelectedConvoApplyDetails=async ()=>{
          setIsAppLoaded(false);
         // alert("sending...."+selectedType);
      try{       
        //const response=await api.get('/stats',{headers:{'Authorization':`Bearer ${accessToken}`}});
        const response=await viewmyresultapi.post('/getSelectedConvoApplyDetails',{selectedType},{headers:{'Authorization':`Bearer ${accessToken}`}});                            
        //alert(JSON.stringify(response.data.student.payment));
        setConvoApplicationDetails(response.data.student.application);
      setConvoPaymentDetails(response.data.student.payment);        
    }
        catch(err)
        {
          if( err.response.status===403)
            {
              navigate(`/accessdenied`); 
            }
          try{
            const config = { withCredentials: true };
            const x=await loginapi.get('/getAccessToken',config);            
            const nat=x['data']['accessToken'];
            const lt=x['data']['loginType'];
            //alert(nat);
            setAccessToken(nat);
            setRefreshFailed(false);  
                    
           
              if(lt.toLowerCase()==="student")
                {
                      try{       
                        const response=await viewmyresultapi.post('/getSelectedConvoApplyDetails',{selectedType},{headers:{'Authorization':`Bearer ${nat}`}});                            
                        //alert(JSON.stringify(response.data.student));
                         setConvoApplicationDetails(response.data.student.application);
                         setConvoPaymentDetails(response.data.student.payment);       
                    }
                    catch(err)
                    {
                      if( err.response.status===403)
                        {
                          navigate(`/accessdenied`); 
                        }
                      //alert('refresh failed unusual'+JSON.stringify(err));
                      setAccessToken('');
                      setRefreshFailed(true);  
                    }
                  }
            }
            catch(err)
            {
              //alert('dd');
              setAccessToken(''); 
              setRefreshFailed(true);              
            }
        }         
         finally
            {
              setIsAppLoaded(true);
              //alert('app loaded'+accessToken);
            }
    }
  useEffect(()=>{   
    getSelectedConvoApplyDetails();
  },[selectedType]);
  
  const proceedToSubmit = () => {
    if (paymentError.length === 0 ) {
  setShowModal(true);
}
  };

function validateDetails() {
  const errors = [];

  // ✅ Ensure objects exist before checking fields
  const appDetails = convoApplicationDetails || {};
  const payDetails = convoPaymentDetails || {};

  // Validate Application Details
  if (!appDetails.applied_name?.trim()) {
    errors.push("Applicant name is required.");
  }
  if (!appDetails.applied_assamiese_name?.trim()) {
    errors.push("Applicant Assamese name is required.");
  }
  if (!appDetails.applied_yop?.trim()) {
    errors.push("Year of Passing is required.");
  }

  // Validate Payment Details
  if (!payDetails.amount) {
    errors.push("Payment amount is required.");
  }
  if (!payDetails.transaction_no?.trim()) {
    errors.push("Transaction number is required.");
  }
  if (!payDetails.images || payDetails.images.length === 0) {
    errors.push("Payment receipt image must be uploaded.");
  }
   if (!appDetails.images || appDetails.images.length === 0) {
    errors.push("Final consolidated Grade Card must be uploaded.");
  }


  setPaymentError(errors);

  return errors.length === 0; // true if no errors
}

   const handleSubmitForm =async (formData)=>{
   // console.log("Updated Data:", updatedData);
    //setFormData(updatedData);
    //alert("l");
    validateDetails();
    try{
          const response= await viewmyresultapi.post('/submitConvocationApplication',formData,{headers:{'Authorization':`Bearer ${accessToken}`}});      
         setConvoApplicationDetails(response.data.pd);
          }
          catch(err)
          {
              try{
              const config = { withCredentials: true };
              const x=await loginapi.get('/getAccessToken',config);
              //alert(JSON.stringify(x['data']['accessToken']));
              
              const nat=x['data']['accessToken'];
              setAccessToken(nat);
              //console.log(`ne at ${nat}`);
              //console.log(`Second at:${accessToken}`);
              try{       
                  const response= await viewmyresultapi.post('/submitConvocationApplication',formData,{headers:{'Authorization':`Bearer ${nat}`}});      
                 setConvoApplicationDetails(response.data.pd);
              }
              catch(err)
              {
                  alert('unusual error newposts.js');
                 
                  //navigate('/');
              }
              }
              catch(err)
              {
              alert('failed');
             
              //setError(JSON.stringify(err));
              //navigate('/');
              }

          }
  };

const handleDownload=async (e)=>{
    setIsAppLoaded(false);
  e.preventDefault();
  try{
    //alert(img+" "+postId);
    //post request to deletePhoto wit {id,fileName}
    setIsAppLoaded(false);
    const response= await viewmyresultapi.post('/getMyFormFillup',{semester:selectedSemester},{headers:{'Authorization':`Bearer ${accessToken}`}});    
    alert(response.data);
    downloadFile(response.data);
  }
  catch(err)
  {
    try{
      const config = { withCredentials: true };
      const x=await loginapi.get('/getAccessToken',config);
      //alert(JSON.stringify(x['data']['accessToken']));
      
      const nat=x['data']['accessToken'];
      setAccessToken(nat);
      //console.log(`ne at ${nat}`);
      //console.log(`Second at:${accessToken}`);
      //alert('ok');
      try{       
        const response= await viewmyresultapi.post('/getMyFormFillup',{semester:selectedSemester},{headers:{'Authorization':`Bearer ${nat}`}});    
        alert(JSON.stringify(response.data));
        downloadFile(response.data);
       }
       catch(err)
       {
        
        alert('unusual error newposts.js');
        setIsAppLoaded(true);
        //alert(JSON.stringify(err));
        //navigate('/');
       }
    }
    catch(err)
    {
      alert(JSON.stringify(err));
      setIsAppLoaded(true);
      //setError(JSON.stringify(err));
      //navigate('/');
    }

  }
}


  function downloadFile(fname)
  {
    fetch(`${APISERVERURL}/studentpdf/${fname}`).then((response) => {
      response.blob().then((blob) => {         
          // Creating new object of PDF file
          const fileURL =
              window.URL.createObjectURL(blob);
               
          // Setting various property values
          let alink = document.createElement("a");
          alink.href = fileURL;
          alink.download = fname;
          alink.click();
          setIsAppLoaded(true);
      });
    });
  }

  const handleGoBack = () => {
    navigate(`/`); 
  };
   
  const loadOfferedCourses=async ()=>{
    //alert(JSON.stringify(loggedInStudent)+" selected sem "+selectedSemester);
     try{       
       //const response=await api.get('/stats',{headers:{'Authorization':`Bearer ${accessToken}`}});
       const response=await viewmyresultapi.post('/getOfferedCourses',{program:loggedInStudent.programme_code,specialisation:loggedInStudent.MajorSub,semester:selectedSemester},{headers:{'Authorization':`Bearer ${accessToken}`}});                            
       //alert("load courses "+JSON.stringify(response.data));
       setSemOfferedCourses(response.data);
       //alert(response.data);
       }
       catch(err)
       {
         try{
           const config = { withCredentials: true };
           const x=await loginapi.get('/getAccessToken',config);            
           const nat=x['data']['accessToken'];
           const ufn=x['data']['userFullName'];
           const un=x['data']['userName'];
           const lt=x['data']['loginType'];
           //alert(nat);
           setAccessToken(nat);
           setRefreshFailed(false);  
                   
          
             if(lt.toLowerCase()==="student")
               {
                     try{       
                       //const response=await api.get('/stats',{headers:{'Authorization':`Bearer ${accessToken}`}});
                       const response=await viewmyresultapi.post('/getOfferedCourses',{program:loggedInStudent.programme_code,specialisation:loggedInStudent.MajorSub,semester:selectedSemester},{headers:{'Authorization':`Bearer ${nat}`}});                            
                       //alert("load courses "+JSON.stringify(response.data));
                       setSemOfferedCourses(response.data);
                       //alert(response.data);
                   }
                   catch(err)
                   {
                     alert('refresh failed unusual'+ "line 50");
                     setAccessToken('');
                     setRefreshFailed(true);  
                   }
                 }
           }
           catch(err)
           {
             //alert('dd');
             setAccessToken(''); 
             setRefreshFailed(true);              
           }
       }         
        finally
           {
             setIsAppLoaded(true);
             //alert('app loaded'+accessToken);
           }
   }
 
   const loadSelectedCourses=async ()=>{
     //alert(JSON.stringify(loggedInStudent)+" selected sem "+selectedSemester);
      try{       
        //const response=await api.get('/stats',{headers:{'Authorization':`Bearer ${accessToken}`}});
        const response=await viewmyresultapi.post('/getSemesterSelectedCourses',{semester:selectedSemester,session:session},{headers:{'Authorization':`Bearer ${accessToken}`}});                            
        //alert(JSON.stringify( response.data.data)); 
        setSelectedCourses(response.data.data);
        //alert(response.data);
        }
        catch(err)
        {
          try{
            const config = { withCredentials: true };
            const x=await loginapi.get('/getAccessToken',config);            
            const nat=x['data']['accessToken'];
            const ufn=x['data']['userFullName'];
            const un=x['data']['userName'];
            const lt=x['data']['loginType'];
            //alert(nat);
            setAccessToken(nat);
            setRefreshFailed(false);  
                    
           
              if(lt.toLowerCase()==="student")
                {
                      try{       
                        //const response=await api.get('/stats',{headers:{'Authorization':`Bearer ${accessToken}`}});
                        const response=await viewmyresultapi.post('/getSemesterSelectedCourses',{semester:selectedSemester,session:session},{headers:{'Authorization':`Bearer ${nat}`}});                            
                        //alert(JSON.stringify(response.data.data)); 
                        setSelectedCourses(response.data.data);
                        //alert(response.data);
                    }
                    catch(err)
                    {
                      alert('refresh failed unusual'+ "line 50");
                      setAccessToken('');
                      setRefreshFailed(true);  
                    }
                  }
            }
            catch(err)
            {
              //alert('dd');
              setAccessToken(''); 
              setRefreshFailed(true);              
            }
        }         
         finally
            {
              setIsAppLoaded(true);
              //alert('app loaded'+accessToken);
            }
   }
   const loadSubmissionStatus=async ()=>{
     //alert(JSON.stringify(loggedInStudent)+" selected sem "+selectedSemester);
      try{       
        //const response=await api.get('/stats',{headers:{'Authorization':`Bearer ${accessToken}`}});
        const response=await viewmyresultapi.post('/loadSubmissionStatus',{semester:selectedSemester,session:session},{headers:{'Authorization':`Bearer ${accessToken}`}});                            
        //alert(JSON.stringify( response.data.data)); 
        setSubmissionStatus(response.data.submissionStatus);
        //alert(response.data.submissionStatus);
        }
        catch(err)
        {
          try{
            const config = { withCredentials: true };
            const x=await loginapi.get('/getAccessToken',config);            
            const nat=x['data']['accessToken'];
            const ufn=x['data']['userFullName'];
            const un=x['data']['userName'];
            const lt=x['data']['loginType'];
            //alert(nat);
            setAccessToken(nat);
            setRefreshFailed(false);  
                    
           
              if(lt.toLowerCase()==="student")
                {
                      try{       
                        //const response=await api.get('/stats',{headers:{'Authorization':`Bearer ${accessToken}`}});
                        const response=await viewmyresultapi.post('/loadSubmissionStatus',{semester:selectedSemester,session:session},{headers:{'Authorization':`Bearer ${nat}`}});                            
                        //alert(JSON.stringify(response.data.data)); 
                        //setSelectedCourses(response.data.data);
                         setSubmissionStatus(response.data.submissionStatus);
                         //alert(response.data.submissionStatus);
                    }
                    catch(err)
                    {
                      alert('refresh failed unusual'+ "line 50");
                      setAccessToken('');
                      setRefreshFailed(true);  
                    }
                  }
            }
            catch(err)
            {
              //alert('dd');
              setAccessToken(''); 
              setRefreshFailed(true);              
            }
        }         
         finally
            {
              setIsAppLoaded(true);
              //alert('app loaded'+accessToken);
            }
   }

   const loadOpenStatus=async ()=>{
     //alert(JSON.stringify(loggedInStudent)+" selected sem "+selectedSemester);
      try{       
        //const response=await api.get('/stats',{headers:{'Authorization':`Bearer ${accessToken}`}});
        const response=await viewmyresultapi.post('/loadOpenStatus',{semester:selectedSemester,session:session},{headers:{'Authorization':`Bearer ${accessToken}`}});                            
        //alert(JSON.stringify( response.data.data)); 
        setIsOpen(response.data.status);
        //alert(response.data.submissionStatus);
        }
        catch(err)
        {
          try{
            const config = { withCredentials: true };
            const x=await loginapi.get('/getAccessToken',config);            
            const nat=x['data']['accessToken'];
            const ufn=x['data']['userFullName'];
            const un=x['data']['userName'];
            const lt=x['data']['loginType'];
            //alert(nat);
            setAccessToken(nat);
            setRefreshFailed(false);  
                    
           
              if(lt.toLowerCase()==="student")
                {
                      try{       
                        //const response=await api.get('/stats',{headers:{'Authorization':`Bearer ${accessToken}`}});
                        const response=await viewmyresultapi.post('/loadOpenStatus',{semester:selectedSemester,session:session},{headers:{'Authorization':`Bearer ${nat}`}});                            
                        //alert(JSON.stringify(response.data.data)); 
                        //setSelectedCourses(response.data.data);
                         setIsOpen(response.data.status);
                         //alert(response.data.submissionStatus);
                    }
                    catch(err)
                    {
                      alert('refresh failed unusual'+ "line 50");
                      setAccessToken('');
                      setRefreshFailed(true);  
                    }
                  }
            }
            catch(err)
            {
              //alert('dd');
              setAccessToken(''); 
              setRefreshFailed(true);              
            }
        }         
         finally
            {
              setIsAppLoaded(true);
              //alert('app loaded'+accessToken);
            }
   }

   useEffect( ()=>{
    if(loggedInStudent)
    {
      //loadOpenStatus();
      //loadSubmissionStatus();      
    }
  },[selectedSemester]);

     useEffect( ()=>{
      validateDetails();
  },[convoApplicationDetails,convoPaymentDetails]);

  const onSemClick = async (event) => {
    setSelectedSemester(event.target.value);
    //retrieve offered courses for the prog specialisation and sem     
  };

  function getSelectSemesterPanel()
  {
    const noofsem=8;
    const semesters =Array.from({ length: noofsem }, (_, index) => ({
      id: index + 1,
      text: `sem${index + 1}`
    }));
    return (
      <div className="semcontainer marginTopm">       
        <div className="album">
          {semesters.map(item => (
            <button
              value={item.id}
              key={item.id}
              className={ item.id==selectedSemester?'circlebutton circularbuttonactive':'circlebutton circularbuttoninactive'}
              onClick={(e)=>{onSemClick(e)}}
            >
              {item.text}
            </button>
          ))}
        </div>
      </div>
    );
  }
  
  function getOfferedCourses()
  {
    return (
      <div className="verticaldiv centrediv fullWidth marginTopm">
         <OfferedCoursesS accessToken={accessToken} 
                setAccessToken={setAccessToken}
                setRefreshFailed={setRefreshFailed} session={session} data={semOfferedCourses} setSelectedCourses={setSelectedCourses} selectedCourses={selectedCourses} semester={selectedSemester} />
      </div>
    );
  }

const onImageUpload=async (e,formData)=>
      {
         e.preventDefault();   
         
          try{
          const response= await viewmyresultapi.post('/updateConvocationTransaction',formData,{headers:{'Authorization':`Bearer ${accessToken}`}});      
         setConvoPaymentDetails(response.data.pd);
          }
          catch(err)
          {
              try{
              const config = { withCredentials: true };
              const x=await loginapi.get('/getAccessToken',config);
              //alert(JSON.stringify(x['data']['accessToken']));
              
              const nat=x['data']['accessToken'];
              setAccessToken(nat);
              //console.log(`ne at ${nat}`);
              //console.log(`Second at:${accessToken}`);
              try{       
                  const response= await viewmyresultapi.post('/updateConvocationTransaction',formData,{headers:{'Authorization':`Bearer ${nat}`}});      
                 setConvoPaymentDetails(response.data.pd);
              }
              catch(err)
              {
                  alert('unusual error newposts.js');
                 
                  //navigate('/');
              }
              }
              catch(err)
              {
              alert('failed');
             
              //setError(JSON.stringify(err));
              //navigate('/');
              }

          }
        }

        
const onMarksheetUpload=async (e,formData)=>
      {
         e.preventDefault();   
         
          try{
          const response= await viewmyresultapi.post('/uploadConvocationMarksheet',formData,{headers:{'Authorization':`Bearer ${accessToken}`}});      
         setConvoApplicationDetails(response.data.pd);
          }
          catch(err)
          {
              try{
              const config = { withCredentials: true };
              const x=await loginapi.get('/getAccessToken',config);
              //alert(JSON.stringify(x['data']['accessToken']));
              
              const nat=x['data']['accessToken'];
              setAccessToken(nat);
              //console.log(`ne at ${nat}`);
              //console.log(`Second at:${accessToken}`);
              try{       
                  const response= await viewmyresultapi.post('/uploadConvocationMarksheet',formData,{headers:{'Authorization':`Bearer ${nat}`}});      
                 setConvoApplicationDetails(response.data.pd);
              }
              catch(err)
              {
                  alert('unusual error newposts.js');
                 
                  //navigate('/');
              }
              }
              catch(err)
              {
              alert('failed');
             
              //setError(JSON.stringify(err));
              //navigate('/');
              }

          }
        }

function formatDate(dateString) {
  const date = new Date(dateString);
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0'); // months are 0-based
  const year = date.getFullYear();
  return `${day}/${month}/${year}`;
}


    return (
      <main className="w-full">

        <div className="flex flex-col items-center w-full">

        <div className="w-full bg-red-100 relative py-1">
            {/* Absolute Positioned Button */}
            <button  onClick={handleGoBack}  className="absolute top-1.5 left-1.5 bg-red-500 text-white px-4 py-2 rounded-lg shadow-md hover:bg-red-600 transition duration-300 text-xs">
              BACK
            </button>

            {/* Heading */}
            <h1 className="text-2xl  text-gray-400 text-center">APPLY FINAL CERTIFICATE</h1>
            <p className="w-full text-center text-xs text-gray-500 text-transparent"> <span>2025-May Examinations</span></p>     
          </div>

          <div className="w-full mt-4 flex flex-col items-center justify-center">
          {isAppLoaded ? ( 
            <>
         
            {loggedInStudent&&loggedInStudent.exists&&loggedInStudent.isOpen==="yes"&&<div className="w-full flex flex-col justify_center items_center">
              <p className="w-full text-gray-800 text-xl text-center">Convocation # {loggedInStudent.student.convocation_no} </p>
               <p className="w-full text-gray-400  text-center" >Welcome  <span className="w-full text-gray-800 text-xl text-center">{loggedInStudent.student.name} </span></p>

<div className="w-full p-2 bg-gray-100 flex justify-evenly flex-wrap gap-2">
  {applicationTypes.map((type, index) => (
    <button
      key={index}
      className="px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600"
      onClick={() => setSelectedType(type)}
    >
      {type}-APPLICATION
    </button>
  ))}
</div>
               {convoPaymentDetails && convoApplicationDetails && (<div className="w-full flex flex-col justify-center items-center gap-2 ">
                <ApplicationForm data={convoApplicationDetails} onSave={handleSave} pdata={convoPaymentDetails} ponSave={handlepSave}/>
                <PaymentDetailsForm data={convoPaymentDetails} onImageUpload={onImageUpload} submissionStatus={(!convoApplicationDetails.applied_status||convoApplicationDetails.applied_status===""||convoApplicationDetails.applied_status==="no")?"no":"yes"}/>
                 <MarksheetForm data={convoApplicationDetails} onImageUpload={onMarksheetUpload} submissionStatus={(!convoApplicationDetails.applied_status||convoApplicationDetails.applied_status===""||convoApplicationDetails.applied_status==="no")?"no":"yes"}/>
                <div className="w-full max-w-[600px]">
  {paymentError.map((err, index) => (
    <p key={index} className="text-red-600 text-sm mb-1">
      {err}
    </p>
  ))}
</div>
                  <div className="w-full max-w-[600px] ">
                  <DeleteConfirmation
              isOpen={showModal}
              yesButtonText="CONFIRM"
              warningMessageText="You won't be able to make changes after submission. Please make sure everything is done correctly before submission. Click on CONFIRM if you are sure."
              onCancel={() => setShowModal(false)}
              onDelete={() => {
                setShowModal(false);
                //call the actual delete function
                handleSubmitForm(convoApplicationDetails);                
              }}
            />  
                 </div>
                 <div  className="w-full max-w-[600px] flex justify-end">
                  { (!convoApplicationDetails.applied_status||convoApplicationDetails.applied_status===""||convoApplicationDetails.applied_status==="no")&&<button
  onClick={proceedToSubmit}
  className="flex items-center gap-2 px-4 py-2 text-white text-xs rounded-lg shadow-md transition duration-300 
             bg-green-500 hover:bg-green-800 m-1"
>
  <FaSave className="w-5 h-5" />
  SUBMIT
</button>}

 { (convoApplicationDetails.applied_status&&convoApplicationDetails.applied_status==="yes")&&
 <p className="w-full text-center p-2 text-gray-700 text-l">
  Already submitted on {formatDate(convoApplicationDetails.applied_on)}
  </p>}
                 </div>
                
                 
                </div>)}
              </div>}
              {(!loggedInStudent || !loggedInStudent.exists||loggedInStudent.isOpen==='no')&&<div className="flex flex-col justify_center items_center">
              <p>Not open! </p>
              </div>}
                
            </>           
          ) : (
            <p>Please wait...</p>
          )}
          </div>
        </div>

     
      </main>
    )
  }
  
  export default ApplyConvocaation